import { InspectorPanelAccordionExport } from "../accordion/export/InspectorPanelAccordionExport"
import { useAppSelector } from "integrations/redux/hooks"
import { selectInfraredImagesAndUploadsByFlightId } from "features/entity-caching/images/hotspots/selectors"
import { useFirePerimeterDownloadButtonData } from "plugins/DrawPerimeter/useFirePerimeterDownloadButtonData"
import { InspectorPanelMetadata } from "../FlightPanelMetadata"
import { GenericUpload, SidePanelLayer } from "@nova/constants"
import { InspectorPanelAccordionIntegrations } from "../accordion/integrations/InspectorPanelAccordionIntegrations"
import { selectFirePerimeterById } from "features/entity-caching/fire-perimeters/selectors"

export const InspectorPanelFirePerimeterData = ({ id }: { id: string }) => {
    const perimeter = useAppSelector(selectFirePerimeterById(id))
    const uploads = useAppSelector(selectInfraredImagesAndUploadsByFlightId(id))
    const downloadOptions = useFirePerimeterDownloadButtonData()

    return (
        <div className="mb-2 flex flex-col gap-2">
            {/* Export */}
            <InspectorPanelAccordionExport
                exportOptions={downloadOptions.exportOptions}
                canOnlyPickOne={true}
            />

            {/* Integrations */}
            <InspectorPanelAccordionIntegrations
                id={id}
                integrationOptions={downloadOptions.integrationOptions}
            />

            <InspectorPanelMetadata
                entity={perimeter as SidePanelLayer}
                uploads={uploads as GenericUpload[]}
                completedUploadCount={1}
            />
        </div>
    )
}
